import { writable } from 'svelte/store';
export const storeBackendUrl = writable("");
export const storeAccessToken = writable("");
export const storeError = writable("");
export const storeIsOpenNewsletterRegistration = writable(false);
export const storeNewsletterRegistrationTitle = writable("");
export const storeNewsletterRegistrationText = writable("");
export const storeNewsletterRegistrationImage = writable("");
export const storeLoader = writable(false);
